import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'

export const getCatalogFederalEntities = async ({ commit }, params = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/federal-entities${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getNextFederalEntityCode = async ({ commit }) => {
    try {
        const { data: result } = await catalogsClient.get(`/federal-entities/next-code`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogFederalEntity = async ({ commit }, payload) => {
    try {
        const { data: result } = await catalogsClient.post(`/federal-entities/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
